// controllers
import GateController from '../../assets/js/controllers/gate';
import ModalController from '../../assets/js/controllers/modal';

// constants
import GateEvent from '../../assets/js/constants/gate-event';

// helpers
import { multiAddEventListener, multiRemoveEventListener } from '../../assets/js/helpers';

export default class WrapperResourceDetail {

	static selector = 'wrapper-resource-detail';

	// class variables

	el = {};

	states = {
		pendingDownload: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			ctasDownloadGated: container.querySelectorAll('[data-cta-download-gated]')
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add and remove listeners

	#addEventListeners = () => {
		multiAddEventListener(this.el.ctasDownloadGated, 'click', this.#onCtaDownloadClick);
		document.body.addEventListener(GateEvent.CANCEL, this.#onGateCancel);
		document.body.addEventListener(GateEvent.UNLOCK, this.#onGateUnlocked);
	}

	#removeEventListeners = () => {
		multiRemoveEventListener(this.el.ctasDownloadGated, 'click', this.#onCtaDownloadClick);
		document.body.removeEventListener(GateEvent.CANCEL, this.#onGateCancel);
		document.body.removeEventListener(GateEvent.UNLOCK, this.#onGateUnlocked);
	}

	// listener methods

	#onCtaDownloadClick = (e) => {
		const $target = e.currentTarget;
		if (GateController.needsGate($target.dataset.ctaDownloadGated)) {
			e.preventDefault();
			e.stopImmediatePropagation();
			this.states.pendingDownload = $target.getAttribute('href');
			ModalController.open($target.dataset.ctaDownloadGated);
		}
	}

	#onGateCancel = () => {
		this.states.pendingDownload = null;
	}

	#onGateUnlocked = () => {
		if (this.states.pendingDownload) {
			window.open(this.states.pendingDownload);
			this.states.pendingDownload = null;
		}
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
